<b>{{heading}}</b>
<div>
    <div *ngFor="let field of fields">
        <div class="psdk-grid-filter">
            <span class="psdk-details-fields-label">{{field.label}}</span>
            <span style="margin: 8px 0px;">{{field.value}}</span>
        </div>
    </div>
</div>
